import { render, staticRenderFns } from "./KpiScoreBars.vue?vue&type=template&id=a6b9e6ac&"
import script from "./KpiScoreBars.vue?vue&type=script&lang=js&"
export * from "./KpiScoreBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports